import { cva, VariantProps } from "class-variance-authority";
import { Testable } from "~/lib/testing";
import { cn } from "~/lib/utils";

const variants = cva("flex h-[26px] items-center justify-center rounded-md px-3.5 py-[5px]", {
    variants: {
        color: {
            blue: ["bg-accent-sky-blue text-blue-100"],
            gray: ["bg-blue-20 text-gray-80"],
            green: ["bg-accent-green text-gray-80"],
        },
    },
    defaultVariants: {
        color: "blue",
    },
});

interface TagProps extends Testable, VariantProps<typeof variants> {
    text: string;
}

export function Tag({ text, "data-test-class": dataTestClass, role, color }: TagProps) {
    return (
        <div className={cn(variants({ color }))}>
            <div className="font-header-xxs uppercase" data-test-class={dataTestClass} role={role}>
                {text}
            </div>
        </div>
    );
}
